var global = require("./shim/global.js");
var v10262;
var v10262;
(function (p12872) {
  if (true) {
    module.exports = p12872();
  } else {
    var v10263;
  }
})(function () {
  return function f1611(p12873, p12874, p12875) {
    function f1612(p12876, p12877) {
      if (!p12874[p12876]) {
        if (!p12873[p12876]) {
          var v10264 = typeof v10262 == "function" && v10262;
          if (!p12877 && v10264) {
            return v10262(p12876, true);
          }
          if (v10268) {
            return v10268(p12876, true);
          }
          var v10265 = new Error("Cannot find module '" + p12876 + "'");
          v10265.code = "MODULE_NOT_FOUND";
          throw v10265;
        }
        var v10266 = p12874[p12876] = {
          exports: {}
        };
        p12873[p12876][0].call(v10266.exports, function (p12878) {
          var v10267 = p12873[p12876][1][p12878];
          return f1612(v10267 ? v10267 : p12878);
        }, v10266, v10266.exports, f1611, p12873, p12874, p12875);
      }
      return p12874[p12876].exports;
    }
    var v10268 = typeof v10262 == "function" && v10262;
    for (var vLN01641 = 0; vLN01641 < p12875.length; vLN01641++) {
      f1612(p12875[vLN01641]);
    }
    return f1612;
  }({
    1: [function (p12879, p12880) {
      (function (p12881) {
        'use strict';

        function f1613() {
          v10278 = true;
          var v10269;
          var v10270;
          for (var v10271 = vA563.length; v10271;) {
            v10270 = vA563;
            vA563 = [];
            v10269 = -1;
            while (++v10269 < v10271) {
              v10270[v10269]();
            }
            v10271 = vA563.length;
          }
          v10278 = false;
        }
        function f1614(p12882) {
          if (vA563.push(p12882) === 1 && !v10278) {
            v10272();
          }
        }
        var v10272;
        var v10273 = p12881.MutationObserver || p12881.WebKitMutationObserver;
        if (v10273) {
          var vLN01642 = 0;
          var v10274 = new v10273(f1613);
          var v10275 = p12881.document.createTextNode("");
          v10274.observe(v10275, {
            characterData: true
          });
          v10272 = function () {
            v10275.data = vLN01642 = ++vLN01642 % 2;
          };
        } else if (!p12881.setImmediate && typeof p12881.MessageChannel != "undefined") {
          var v10276 = new p12881.MessageChannel();
          v10276.port1.onmessage = f1613;
          v10272 = function () {
            v10276.port2.postMessage(0);
          };
        } else {
          v10272 = "document" in p12881 && "onreadystatechange" in p12881.document.createElement("script") ? function () {
            var v10277 = p12881.document.createElement("script");
            v10277.onreadystatechange = function () {
              f1613();
              v10277.onreadystatechange = null;
              v10277.parentNode.removeChild(v10277);
              v10277 = null;
            };
            p12881.document.documentElement.appendChild(v10277);
          } : function () {
            requestAnimationFrame(f1613, 0);
          };
        }
        var v10278;
        var vA563 = [];
        p12880.exports = f1614;
      }).call(this, typeof global == "undefined" ? typeof self == "undefined" ? typeof window == "undefined" ? {} : window : self : global);
    }, {}],
    2: [function (p12883, p12884, p12885) {
      'use strict';

      function f1615() {}
      function f1616(p12886) {
        if (typeof p12886 != "function") {
          throw new TypeError("resolver must be a function");
        }
        this.state = vA566;
        this.queue = [];
        this.outcome = undefined;
        if (p12886 !== f1615) {
          f1621(this, p12886);
        }
      }
      function f1617(p12887, p12888, p12889) {
        this.promise = p12887;
        if (typeof p12888 == "function") {
          this.onFulfilled = p12888;
          this.callFulfilled = this.otherCallFulfilled;
        }
        if (typeof p12889 == "function") {
          this.onRejected = p12889;
          this.callRejected = this.otherCallRejected;
        }
      }
      function f1618(p12890, p12891, p12892) {
        vP12883(function () {
          var v10279;
          try {
            v10279 = p12891(p12892);
          } catch (e95) {
            return vO320.reject(p12890, e95);
          }
          if (v10279 === p12890) {
            vO320.reject(p12890, new TypeError("Cannot resolve promise with itself"));
          } else {
            vO320.resolve(p12890, v10279);
          }
        });
      }
      function f1619(p12893) {
        var v10280 = p12893 && p12893.then;
        if (p12893 && (typeof p12893 == "object" || typeof p12893 == "function") && typeof v10280 == "function") {
          return function f1620() {
            v10280.apply(p12893, arguments);
          };
        }
      }
      function f1621(p12894, p12895) {
        function f1622(p12896) {
          if (!v10281) {
            v10281 = true;
            vO320.reject(p12894, p12896);
          }
        }
        function f1623(p12897) {
          if (!v10281) {
            v10281 = true;
            vO320.resolve(p12894, p12897);
          }
        }
        function f1624() {
          p12895(f1623, f1622);
        }
        var v10281 = false;
        var vIi37 = f1625(f1624);
        if (vIi37.status === "error") {
          f1622(vIi37.value);
        }
      }
      function f1625(p12898, p12899) {
        var vO319 = {};
        try {
          vO319.value = p12898(p12899);
          vO319.status = "success";
        } catch (e96) {
          vO319.status = "error";
          vO319.value = e96;
        }
        return vO319;
      }
      function f1626(p12900) {
        if (p12900 instanceof this) {
          return p12900;
        } else {
          return vO320.resolve(new this(f1615), p12900);
        }
      }
      function f1627(p12901) {
        var v10282 = new this(f1615);
        return vO320.reject(v10282, p12901);
      }
      function f1628(p12902) {
        function f1629(p12903, p12904) {
          function f1630(p12905) {
            vArray59[p12904] = p12905;
            if (++vLN01643 === v10283 && !v10284) {
              v10284 = true;
              vO320.resolve(v10286, vArray59);
            }
          }
          vThis95.resolve(p12903).then(f1630, function (p12906) {
            if (!v10284) {
              v10284 = true;
              vO320.reject(v10286, p12906);
            }
          });
        }
        var vThis95 = this;
        if (Object.prototype.toString.call(p12902) !== "[object Array]") {
          return this.reject(new TypeError("must be an array"));
        }
        var v10283 = p12902.length;
        var v10284 = false;
        if (!v10283) {
          return this.resolve([]);
        }
        var vArray59 = Array(v10283);
        var vLN01643 = 0;
        for (var v10285 = -1, v10286 = new this(f1615); ++v10285 < v10283;) {
          f1629(p12902[v10285], v10285);
        }
        return v10286;
      }
      function f1631(p12907) {
        function f1632(p12908) {
          vThis96.resolve(p12908).then(function (p12909) {
            if (!v10288) {
              v10288 = true;
              vO320.resolve(v10290, p12909);
            }
          }, function (p12910) {
            if (!v10288) {
              v10288 = true;
              vO320.reject(v10290, p12910);
            }
          });
        }
        var vThis96 = this;
        if (Object.prototype.toString.call(p12907) !== "[object Array]") {
          return this.reject(new TypeError("must be an array"));
        }
        var v10287 = p12907.length;
        var v10288 = false;
        if (!v10287) {
          return this.resolve([]);
        }
        for (var v10289 = -1, v10290 = new this(f1615); ++v10289 < v10287;) {
          f1632(p12907[v10289]);
        }
        return v10290;
      }
      var vP12883 = p12883(1);
      var vO320 = {};
      var vA564 = ["REJECTED"];
      var vA565 = ["FULFILLED"];
      var vA566 = ["PENDING"];
      p12884.exports = f1616;
      f1616.prototype.catch = function (p12911) {
        return this.then(null, p12911);
      };
      f1616.prototype.then = function (p12912, p12913) {
        if (typeof p12912 != "function" && this.state === vA565 || typeof p12913 != "function" && this.state === vA564) {
          return this;
        }
        var v10291 = new this.constructor(f1615);
        if (this.state !== vA566) {
          var v10292 = this.state === vA565 ? p12912 : p12913;
          f1618(v10291, v10292, this.outcome);
        } else {
          this.queue.push(new f1617(v10291, p12912, p12913));
        }
        return v10291;
      };
      f1617.prototype.callFulfilled = function (p12914) {
        vO320.resolve(this.promise, p12914);
      };
      f1617.prototype.otherCallFulfilled = function (p12915) {
        f1618(this.promise, this.onFulfilled, p12915);
      };
      f1617.prototype.callRejected = function (p12916) {
        vO320.reject(this.promise, p12916);
      };
      f1617.prototype.otherCallRejected = function (p12917) {
        f1618(this.promise, this.onRejected, p12917);
      };
      vO320.resolve = function (p12918, p12919) {
        var vF1625 = f1625(f1619, p12919);
        if (vF1625.status === "error") {
          return vO320.reject(p12918, vF1625.value);
        }
        var v10293 = vF1625.value;
        if (v10293) {
          f1621(p12918, v10293);
        } else {
          p12918.state = vA565;
          p12918.outcome = p12919;
          for (var v10294 = -1, v10295 = p12918.queue.length; ++v10294 < v10295;) {
            p12918.queue[v10294].callFulfilled(p12919);
          }
        }
        return p12918;
      };
      vO320.reject = function (p12920, p12921) {
        p12920.state = vA564;
        p12920.outcome = p12921;
        for (var v10296 = -1, v10297 = p12920.queue.length; ++v10296 < v10297;) {
          p12920.queue[v10296].callRejected(p12921);
        }
        return p12920;
      };
      f1616.resolve = f1626;
      f1616.reject = f1627;
      f1616.all = f1628;
      f1616.race = f1631;
    }, {
      1: 1
    }],
    3: [function (p12922, p12923, p12924) {
      (function (p12925) {
        'use strict';

        if (typeof p12925.Promise != "function") {
          p12925.Promise = p12922(2);
        }
      }).call(this, typeof global == "undefined" ? typeof self == "undefined" ? typeof window == "undefined" ? {} : window : self : global);
    }, {
      2: 2
    }],
    4: [function (p12926, p12927, p12928) {
      'use strict';

      function f1633(p12929, p12930) {
        if (!(p12929 instanceof p12930)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function f1634() {
        try {
          if (typeof indexedDB != "undefined") {
            return indexedDB;
          }
          if (typeof webkitIndexedDB != "undefined") {
            return webkitIndexedDB;
          }
          if (typeof mozIndexedDB != "undefined") {
            return mozIndexedDB;
          }
          if (typeof OIndexedDB != "undefined") {
            return OIndexedDB;
          }
          if (typeof msIndexedDB != "undefined") {
            return msIndexedDB;
          }
        } catch (e97) {
          return;
        }
      }
      function f1635() {
        try {
          if (!vF1634 || !vF1634.open) {
            return false;
          }
          var v10298 = typeof openDatabase != "undefined" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
          var v10299 = typeof fetch == "function" && fetch.toString().indexOf("[native code") !== -1;
          return (!v10298 || v10299) && typeof indexedDB != "undefined" && typeof IDBKeyRange != "undefined";
        } catch (e98) {
          return false;
        }
      }
      function f1636(p12931, p12932) {
        p12931 = p12931 || [];
        p12932 = p12932 || {};
        try {
          return new Blob(p12931, p12932);
        } catch (e99) {
          if (e99.name !== "TypeError") {
            throw e99;
          }
          var v10300 = typeof BlobBuilder == "undefined" ? typeof MSBlobBuilder == "undefined" ? typeof MozBlobBuilder == "undefined" ? WebKitBlobBuilder : MozBlobBuilder : MSBlobBuilder : BlobBuilder;
          var v10301 = new v10300();
          for (var vLN01644 = 0; vLN01644 < p12931.length; vLN01644 += 1) {
            v10301.append(p12931[vLN01644]);
          }
          return v10301.getBlob(p12932.type);
        }
      }
      function f1637(p12933, p12934) {
        if (p12934) {
          p12933.then(function (p12935) {
            p12934(null, p12935);
          }, function (p12936) {
            p12934(p12936);
          });
        }
      }
      function f1638(p12937, p12938, p12939) {
        if (typeof p12938 == "function") {
          p12937.then(p12938);
        }
        if (typeof p12939 == "function") {
          p12937.catch(p12939);
        }
      }
      function f1639(p12940) {
        if (typeof p12940 != "string") {
          console.warn(p12940 + " used as a key, but it is not a string.");
          p12940 += "";
        }
        return p12940;
      }
      function f1640() {
        if (arguments.length && typeof arguments[arguments.length - 1] == "function") {
          return arguments[arguments.length - 1];
        }
      }
      function f1641(p12941) {
        for (var v10302 = p12941.length, v10303 = new ArrayBuffer(v10302), v10304 = new Uint8Array(v10303), vLN01645 = 0; vLN01645 < v10302; vLN01645++) {
          v10304[vLN01645] = p12941.charCodeAt(vLN01645);
        }
        return v10303;
      }
      function f1642(p12942) {
        return new vPromise(function (p12943) {
          var v10305 = p12942.transaction(vLSLocalforagedetectblo, vLSReadwrite);
          var vF1636 = f1636([""]);
          v10305.objectStore(vLSLocalforagedetectblo).put(vF1636, "key");
          v10305.onabort = function (p12944) {
            p12944.preventDefault();
            p12944.stopPropagation();
            p12943(false);
          };
          v10305.oncomplete = function () {
            var v10306 = navigator.userAgent.match(/Chrome\/(\d+)/);
            var v10307 = navigator.userAgent.match(/Edge\//);
            p12943(v10307 || !v10306 || parseInt(v10306[1], 10) >= 43);
          };
        }).catch(function () {
          return false;
        });
      }
      function f1643(p12945) {
        if (typeof vUndefined7 == "boolean") {
          return vPromise.resolve(vUndefined7);
        } else {
          return f1642(p12945).then(function (p12946) {
            vUndefined7 = p12946;
            return vUndefined7;
          });
        }
      }
      function f1644(p12947) {
        var v10308 = vO325[p12947.name];
        var vO321 = {};
        vO321.promise = new vPromise(function (p12948, p12949) {
          vO321.resolve = p12948;
          vO321.reject = p12949;
        });
        v10308.deferredOperations.push(vO321);
        v10308.dbReady = v10308.dbReady ? v10308.dbReady.then(function () {
          return vO321.promise;
        }) : vO321.promise;
      }
      function f1645(p12950) {
        var v10309 = vO325[p12950.name];
        var v10310 = v10309.deferredOperations.pop();
        if (v10310) {
          v10310.resolve();
          return v10310.promise;
        }
      }
      function f1646(p12951, p12952) {
        var v10311 = vO325[p12951.name];
        var v10312 = v10311.deferredOperations.pop();
        if (v10312) {
          v10312.reject(p12952);
          return v10312.promise;
        }
      }
      function f1647(p12953, p12954) {
        return new vPromise(function (p12955, p12956) {
          vO325[p12953.name] = vO325[p12953.name] || f1657();
          if (p12953.db) {
            if (p12954) {
              f1644(p12953);
              p12953.db.close();
            } else {
              return p12955(p12953.db);
            }
          }
          var vA567 = [p12953.name];
          if (p12954) {
            vA567.push(p12953.version);
          }
          var v10313 = vF1634.open.apply(vF1634, vA567);
          if (p12954) {
            v10313.onupgradeneeded = function (p12957) {
              var v10314 = v10313.result;
              try {
                v10314.createObjectStore(p12953.storeName);
                if (p12957.oldVersion <= 1) {
                  v10314.createObjectStore(vLSLocalforagedetectblo);
                }
              } catch (e100) {
                if (e100.name === "ConstraintError") {
                  console.warn("The database \"" + p12953.name + "\" has been upgraded from version " + p12957.oldVersion + " to version " + p12957.newVersion + ", but the storage \"" + p12953.storeName + "\" already exists.");
                } else {
                  throw e100;
                }
              }
            };
          }
          v10313.onerror = function (p12958) {
            p12958.preventDefault();
            p12956(v10313.error);
          };
          v10313.onsuccess = function () {
            var v10315 = v10313.result;
            v10315.onversionchange = function (p12959) {
              p12959.target.close();
            };
            p12955(v10315);
            f1645(p12953);
          };
        });
      }
      function f1648(p12960) {
        return f1647(p12960, false);
      }
      function f1649(p12961) {
        return f1647(p12961, true);
      }
      function f1650(p12962, p12963) {
        if (!p12962.db) {
          return true;
        }
        var v10316 = !p12962.db.objectStoreNames.contains(p12962.storeName);
        var v10317 = p12962.version < p12962.db.version;
        var v10318 = p12962.version > p12962.db.version;
        if (v10317) {
          if (p12962.version !== p12963) {
            console.warn("The database \"" + p12962.name + "\" can't be downgraded from version " + p12962.db.version + " to version " + p12962.version + ".");
          }
          p12962.version = p12962.db.version;
        }
        if (v10318 || v10316) {
          if (v10316) {
            var v10319 = p12962.db.version + 1;
            if (v10319 > p12962.version) {
              p12962.version = v10319;
            }
          }
          return true;
        }
        return false;
      }
      function f1651(p12964) {
        return new vPromise(function (p12965, p12966) {
          var v10320 = new FileReader();
          v10320.onerror = p12966;
          v10320.onloadend = function (p12967) {
            var vBtoa = btoa(p12967.target.result || "");
            p12965({
              __local_forage_encoded_blob: true,
              data: vBtoa,
              type: p12964.type
            });
          };
          v10320.readAsBinaryString(p12964);
        });
      }
      function f1652(p12968) {
        var vF1641 = f1641(atob(p12968.data));
        return f1636([vF1641], {
          type: p12968.type
        });
      }
      function f1653(p12969) {
        return p12969 && p12969.__local_forage_encoded_blob;
      }
      function f1654(p12970) {
        var vThis97 = this;
        var v10321 = vThis97._initReady().then(function () {
          var v10322 = vO325[vThis97._dbInfo.name];
          if (v10322 && v10322.dbReady) {
            return v10322.dbReady;
          }
        });
        f1638(v10321, p12970, p12970);
        return v10321;
      }
      function f1655(p12971) {
        f1644(p12971);
        var v10323;
        var v10324 = vO325[p12971.name];
        for (var v10325 = v10324.forages, vLN01646 = 0; vLN01646 < v10325.length; vLN01646++) {
          v10323 = v10325[vLN01646];
          if (v10323._dbInfo.db) {
            v10323._dbInfo.db.close();
            v10323._dbInfo.db = null;
          }
        }
        p12971.db = null;
        return f1648(p12971).then(function (p12972) {
          p12971.db = p12972;
          if (f1650(p12971)) {
            return f1649(p12971);
          } else {
            return p12972;
          }
        }).then(function (p12973) {
          p12971.db = v10324.db = p12973;
          for (var vLN01647 = 0; vLN01647 < v10325.length; vLN01647++) {
            v10325[vLN01647]._dbInfo.db = p12973;
          }
        }).catch(function (p12974) {
          f1646(p12971, p12974);
          throw p12974;
        });
      }
      function f1656(p12975, p12976, p12977, p12978 = 1) {
        try {
          var v10326 = p12975.db.transaction(p12975.storeName, p12976);
          p12977(null, v10326);
        } catch (e101) {
          if (p12978 > 0 && (!p12975.db || e101.name === "InvalidStateError" || e101.name === "NotFoundError")) {
            return vPromise.resolve().then(function () {
              if (!p12975.db || e101.name === "NotFoundError" && !p12975.db.objectStoreNames.contains(p12975.storeName) && p12975.version <= p12975.db.version) {
                if (p12975.db) {
                  p12975.version = p12975.db.version + 1;
                }
                return f1649(p12975);
              }
            }).then(function () {
              return f1655(p12975).then(function () {
                f1656(p12975, p12976, p12977, p12978 - 1);
              });
            }).catch(p12977);
          }
          p12977(e101);
        }
      }
      function f1657() {
        return {
          forages: [],
          db: null,
          dbReady: null,
          deferredOperations: []
        };
      }
      function f1658(p12979) {
        function f1659() {
          return vPromise.resolve();
        }
        var vThis98 = this;
        var vO322 = {
          db: null
        };
        if (p12979) {
          for (var v10327 in p12979) {
            vO322[v10327] = p12979[v10327];
          }
        }
        var v10328 = vO325[vO322.name];
        if (!v10328) {
          v10328 = f1657();
          vO325[vO322.name] = v10328;
        }
        v10328.forages.push(vThis98);
        if (!vThis98._initReady) {
          vThis98._initReady = vThis98.ready;
          vThis98.ready = f1654;
        }
        var v10329;
        var vA568 = [];
        for (var vLN01648 = 0; vLN01648 < v10328.forages.length; vLN01648++) {
          v10329 = v10328.forages[vLN01648];
          if (v10329 !== vThis98) {
            vA568.push(v10329._initReady().catch(f1659));
          }
        }
        var v10330 = v10328.forages.slice(0);
        return vPromise.all(vA568).then(function () {
          vO322.db = v10328.db;
          return f1648(vO322);
        }).then(function (p12980) {
          vO322.db = p12980;
          if (f1650(vO322, vThis98._defaultConfig.version)) {
            return f1649(vO322);
          } else {
            return p12980;
          }
        }).then(function (p12981) {
          vO322.db = v10328.db = p12981;
          vThis98._dbInfo = vO322;
          var v10331;
          for (var vLN01649 = 0; vLN01649 < v10330.length; vLN01649++) {
            v10331 = v10330[vLN01649];
            if (v10331 !== vThis98) {
              v10331._dbInfo.db = vO322.db;
              v10331._dbInfo.version = vO322.version;
            }
          }
        });
      }
      function f1660(p12982, p12983) {
        var vThis99 = this;
        p12982 = f1639(p12982);
        var v10332 = new vPromise(function (p12984, p12985) {
          vThis99.ready().then(function () {
            f1656(vThis99._dbInfo, vLSReadonly, function (p12986, p12987) {
              if (p12986) {
                return p12985(p12986);
              }
              try {
                var v10333 = p12987.objectStore(vThis99._dbInfo.storeName);
                var v10334 = v10333.get(p12982);
                v10334.onsuccess = function () {
                  var v10335 = v10334.result;
                  if (v10335 === undefined) {
                    v10335 = null;
                  }
                  if (f1653(v10335)) {
                    v10335 = f1652(v10335);
                  }
                  p12984(v10335);
                };
                v10334.onerror = function () {
                  p12985(v10334.error);
                };
              } catch (e102) {
                p12985(e102);
              }
            });
          }).catch(p12985);
        });
        f1637(v10332, p12983);
        return v10332;
      }
      function f1661(p12988, p12989) {
        var vThis100 = this;
        var v10336 = new vPromise(function (p12990, p12991) {
          vThis100.ready().then(function () {
            f1656(vThis100._dbInfo, vLSReadonly, function (p12992, p12993) {
              if (p12992) {
                return p12991(p12992);
              }
              try {
                var v10337 = p12993.objectStore(vThis100._dbInfo.storeName);
                var v10338 = v10337.openCursor();
                var vLN1146 = 1;
                v10338.onsuccess = function () {
                  var v10339 = v10338.result;
                  if (v10339) {
                    var v10340 = v10339.value;
                    if (f1653(v10340)) {
                      v10340 = f1652(v10340);
                    }
                    var vP12988 = p12988(v10340, v10339.key, vLN1146++);
                    if (vP12988 === undefined) {
                      v10339.continue();
                    } else {
                      p12990(vP12988);
                    }
                  } else {
                    p12990();
                  }
                };
                v10338.onerror = function () {
                  p12991(v10338.error);
                };
              } catch (e103) {
                p12991(e103);
              }
            });
          }).catch(p12991);
        });
        f1637(v10336, p12989);
        return v10336;
      }
      function f1662(p12994, p12995, p12996) {
        var vThis101 = this;
        p12994 = f1639(p12994);
        var v10341 = new vPromise(function (p12997, p12998) {
          var v10342;
          vThis101.ready().then(function () {
            v10342 = vThis101._dbInfo;
            if (v10472.call(p12995) === "[object Blob]") {
              return f1643(v10342.db).then(function (p12999) {
                if (p12999) {
                  return p12995;
                } else {
                  return f1651(p12995);
                }
              });
            } else {
              return p12995;
            }
          }).then(function (p13000) {
            f1656(vThis101._dbInfo, vLSReadwrite, function (p13001, p13002) {
              if (p13001) {
                return p12998(p13001);
              }
              try {
                var v10343 = p13002.objectStore(vThis101._dbInfo.storeName);
                if (p13000 === null) {
                  p13000 = undefined;
                }
                var v10344 = v10343.put(p13000, p12994);
                p13002.oncomplete = function () {
                  if (p13000 === undefined) {
                    p13000 = null;
                  }
                  p12997(p13000);
                };
                p13002.onabort = p13002.onerror = function () {
                  var v10345 = v10344.error ? v10344.error : v10344.transaction.error;
                  p12998(v10345);
                };
              } catch (e104) {
                p12998(e104);
              }
            });
          }).catch(p12998);
        });
        f1637(v10341, p12996);
        return v10341;
      }
      function f1663(p13003, p13004) {
        var vThis102 = this;
        p13003 = f1639(p13003);
        var v10346 = new vPromise(function (p13005, p13006) {
          vThis102.ready().then(function () {
            f1656(vThis102._dbInfo, vLSReadwrite, function (p13007, p13008) {
              if (p13007) {
                return p13006(p13007);
              }
              try {
                var v10347 = p13008.objectStore(vThis102._dbInfo.storeName);
                var v10348 = v10347.delete(p13003);
                p13008.oncomplete = function () {
                  p13005();
                };
                p13008.onerror = function () {
                  p13006(v10348.error);
                };
                p13008.onabort = function () {
                  var v10349 = v10348.error ? v10348.error : v10348.transaction.error;
                  p13006(v10349);
                };
              } catch (e105) {
                p13006(e105);
              }
            });
          }).catch(p13006);
        });
        f1637(v10346, p13004);
        return v10346;
      }
      function f1664(p13009) {
        var vThis103 = this;
        var v10350 = new vPromise(function (p13010, p13011) {
          vThis103.ready().then(function () {
            f1656(vThis103._dbInfo, vLSReadwrite, function (p13012, p13013) {
              if (p13012) {
                return p13011(p13012);
              }
              try {
                var v10351 = p13013.objectStore(vThis103._dbInfo.storeName);
                var v10352 = v10351.clear();
                p13013.oncomplete = function () {
                  p13010();
                };
                p13013.onabort = p13013.onerror = function () {
                  var v10353 = v10352.error ? v10352.error : v10352.transaction.error;
                  p13011(v10353);
                };
              } catch (e106) {
                p13011(e106);
              }
            });
          }).catch(p13011);
        });
        f1637(v10350, p13009);
        return v10350;
      }
      function f1665(p13014) {
        var vThis104 = this;
        var v10354 = new vPromise(function (p13015, p13016) {
          vThis104.ready().then(function () {
            f1656(vThis104._dbInfo, vLSReadonly, function (p13017, p13018) {
              if (p13017) {
                return p13016(p13017);
              }
              try {
                var v10355 = p13018.objectStore(vThis104._dbInfo.storeName);
                var v10356 = v10355.count();
                v10356.onsuccess = function () {
                  p13015(v10356.result);
                };
                v10356.onerror = function () {
                  p13016(v10356.error);
                };
              } catch (e107) {
                p13016(e107);
              }
            });
          }).catch(p13016);
        });
        f1637(v10354, p13014);
        return v10354;
      }
      function f1666(p13019, p13020) {
        var vThis105 = this;
        var v10357 = new vPromise(function (p13021, p13022) {
          if (p13019 < 0) {
            p13021(null);
            return;
          } else {
            vThis105.ready().then(function () {
              f1656(vThis105._dbInfo, vLSReadonly, function (p13023, p13024) {
                if (p13023) {
                  return p13022(p13023);
                }
                try {
                  var v10358 = p13024.objectStore(vThis105._dbInfo.storeName);
                  var v10359 = false;
                  var v10360 = v10358.openKeyCursor();
                  v10360.onsuccess = function () {
                    var v10361 = v10360.result;
                    if (v10361) {
                      if (p13019 === 0) {
                        p13021(v10361.key);
                      } else if (v10359) {
                        p13021(v10361.key);
                      } else {
                        v10359 = true;
                        v10361.advance(p13019);
                      }
                      return;
                    } else {
                      p13021(null);
                      return;
                    }
                  };
                  v10360.onerror = function () {
                    p13022(v10360.error);
                  };
                } catch (e108) {
                  p13022(e108);
                }
              });
            }).catch(p13022);
            return;
          }
        });
        f1637(v10357, p13020);
        return v10357;
      }
      function f1667(p13025) {
        var vThis106 = this;
        var v10362 = new vPromise(function (p13026, p13027) {
          vThis106.ready().then(function () {
            f1656(vThis106._dbInfo, vLSReadonly, function (p13028, p13029) {
              if (p13028) {
                return p13027(p13028);
              }
              try {
                var v10363 = p13029.objectStore(vThis106._dbInfo.storeName);
                var v10364 = v10363.openKeyCursor();
                var vA569 = [];
                v10364.onsuccess = function () {
                  var v10365 = v10364.result;
                  if (v10365) {
                    vA569.push(v10365.key);
                    v10365.continue();
                    return;
                  } else {
                    p13026(vA569);
                    return;
                  }
                };
                v10364.onerror = function () {
                  p13027(v10364.error);
                };
              } catch (e109) {
                p13027(e109);
              }
            });
          }).catch(p13027);
        });
        f1637(v10362, p13025);
        return v10362;
      }
      function f1668(p13030, p13031) {
        p13031 = f1640.apply(this, arguments);
        var v10366 = this.config();
        p13030 = typeof p13030 != "function" && p13030 || {};
        if (!p13030.name) {
          p13030.name = p13030.name || v10366.name;
          p13030.storeName = p13030.storeName || v10366.storeName;
        }
        var v10367;
        var vThis107 = this;
        if (!p13030.name) {
          v10367 = vPromise.reject("Invalid arguments");
        } else {
          var v10368 = p13030.name === v10366.name && vThis107._dbInfo.db;
          var v10369 = v10368 ? vPromise.resolve(vThis107._dbInfo.db) : f1648(p13030).then(function (p13032) {
            var v10370 = vO325[p13030.name];
            var v10371 = v10370.forages;
            v10370.db = p13032;
            for (var vLN01650 = 0; vLN01650 < v10371.length; vLN01650++) {
              v10371[vLN01650]._dbInfo.db = p13032;
            }
            return p13032;
          });
          v10367 = p13030.storeName ? v10369.then(function (p13033) {
            if (p13033.objectStoreNames.contains(p13030.storeName)) {
              var v10372 = p13033.version + 1;
              f1644(p13030);
              var v10373 = vO325[p13030.name];
              var v10374 = v10373.forages;
              p13033.close();
              var v10375;
              for (var vLN01651 = 0; vLN01651 < v10374.length; vLN01651++) {
                v10375 = v10374[vLN01651];
                v10375._dbInfo.db = null;
                v10375._dbInfo.version = v10372;
              }
              var v10376 = new vPromise(function (p13034, p13035) {
                var v10377 = vF1634.open(p13030.name, v10372);
                v10377.onerror = function (p13036) {
                  var v10378 = v10377.result;
                  v10378.close();
                  p13035(p13036);
                };
                v10377.onupgradeneeded = function () {
                  var v10379 = v10377.result;
                  v10379.deleteObjectStore(p13030.storeName);
                };
                v10377.onsuccess = function () {
                  var v10380 = v10377.result;
                  v10380.close();
                  p13034(v10380);
                };
              });
              return v10376.then(function (p13037) {
                v10373.db = p13037;
                var v10381;
                for (var vLN01652 = 0; vLN01652 < v10374.length; vLN01652++) {
                  v10381 = v10374[vLN01652];
                  v10381._dbInfo.db = p13037;
                  f1645(v10381._dbInfo);
                }
              }).catch(function (p13038) {
                (f1646(p13030, p13038) || vPromise.resolve()).catch(function () {});
                throw p13038;
              });
            }
          }) : v10369.then(function (p13039) {
            f1644(p13030);
            var v10382 = vO325[p13030.name];
            var v10383 = v10382.forages;
            p13039.close();
            var v10384;
            for (var vLN01653 = 0; vLN01653 < v10383.length; vLN01653++) {
              v10384 = v10383[vLN01653];
              v10384._dbInfo.db = null;
            }
            var v10385 = new vPromise(function (p13040, p13041) {
              var v10386 = vF1634.deleteDatabase(p13030.name);
              v10386.onerror = function () {
                var v10387 = v10386.result;
                if (v10387) {
                  v10387.close();
                }
                p13041(v10386.error);
              };
              v10386.onblocked = function () {
                console.warn("dropInstance blocked for database \"" + p13030.name + "\" until all open connections are closed");
              };
              v10386.onsuccess = function () {
                var v10388 = v10386.result;
                if (v10388) {
                  v10388.close();
                }
                p13040(v10388);
              };
            });
            return v10385.then(function (p13042) {
              v10382.db = p13042;
              var v10389;
              for (var vLN01654 = 0; vLN01654 < v10383.length; vLN01654++) {
                v10389 = v10383[vLN01654];
                f1645(v10389._dbInfo);
              }
            }).catch(function (p13043) {
              (f1646(p13030, p13043) || vPromise.resolve()).catch(function () {});
              throw p13043;
            });
          });
        }
        f1637(v10367, p13031);
        return v10367;
      }
      function f1669() {
        return typeof openDatabase == "function";
      }
      function f1670(p13044) {
        var v10390;
        var v10391;
        var v10392;
        var v10393;
        var v10394;
        var v10395 = p13044.length * 0.75;
        var v10396 = p13044.length;
        var vLN01655 = 0;
        if (p13044[p13044.length - 1] === "=") {
          v10395--;
          if (p13044[p13044.length - 2] === "=") {
            v10395--;
          }
        }
        var v10397 = new ArrayBuffer(v10395);
        var v10398 = new Uint8Array(v10397);
        for (v10390 = 0; v10390 < v10396; v10390 += 4) {
          v10391 = vLSABCDEFGHIJKLMNOPQRST3.indexOf(p13044[v10390]);
          v10392 = vLSABCDEFGHIJKLMNOPQRST3.indexOf(p13044[v10390 + 1]);
          v10393 = vLSABCDEFGHIJKLMNOPQRST3.indexOf(p13044[v10390 + 2]);
          v10394 = vLSABCDEFGHIJKLMNOPQRST3.indexOf(p13044[v10390 + 3]);
          v10398[vLN01655++] = v10391 << 2 | v10392 >> 4;
          v10398[vLN01655++] = (v10392 & 15) << 4 | v10393 >> 2;
          v10398[vLN01655++] = (v10393 & 3) << 6 | v10394 & 63;
        }
        return v10397;
      }
      function f1671(p13045) {
        var v10399;
        var v10400 = new Uint8Array(p13045);
        var vLS41 = "";
        for (v10399 = 0; v10399 < v10400.length; v10399 += 3) {
          vLS41 += vLSABCDEFGHIJKLMNOPQRST3[v10400[v10399] >> 2];
          vLS41 += vLSABCDEFGHIJKLMNOPQRST3[(v10400[v10399] & 3) << 4 | v10400[v10399 + 1] >> 4];
          vLS41 += vLSABCDEFGHIJKLMNOPQRST3[(v10400[v10399 + 1] & 15) << 2 | v10400[v10399 + 2] >> 6];
          vLS41 += vLSABCDEFGHIJKLMNOPQRST3[v10400[v10399 + 2] & 63];
        }
        if (v10400.length % 3 == 2) {
          vLS41 = vLS41.substring(0, vLS41.length - 1) + "=";
        } else if (v10400.length % 3 == 1) {
          vLS41 = vLS41.substring(0, vLS41.length - 2) + "==";
        }
        return vLS41;
      }
      function f1672(p13046, p13047) {
        var vLS42 = "";
        if (p13046) {
          vLS42 = v10476.call(p13046);
        }
        if (p13046 && (vLS42 === "[object ArrayBuffer]" || p13046.buffer && v10476.call(p13046.buffer) === "[object ArrayBuffer]")) {
          var v10401;
          var vIii16 = vLS__lfsc__;
          if (p13046 instanceof ArrayBuffer) {
            v10401 = p13046;
            vIii16 += vLSArbf;
          } else {
            v10401 = p13046.buffer;
            if (vLS42 === "[object Int8Array]") {
              vIii16 += vLSSi08;
            } else if (vLS42 === "[object Uint8Array]") {
              vIii16 += vLSUi08;
            } else if (vLS42 === "[object Uint8ClampedArray]") {
              vIii16 += vLSUic8;
            } else if (vLS42 === "[object Int16Array]") {
              vIii16 += vLSSi16;
            } else if (vLS42 === "[object Uint16Array]") {
              vIii16 += vLSUr16;
            } else if (vLS42 === "[object Int32Array]") {
              vIii16 += vLSSi32;
            } else if (vLS42 === "[object Uint32Array]") {
              vIii16 += vLSUi32;
            } else if (vLS42 === "[object Float32Array]") {
              vIii16 += vLSFl32;
            } else if (vLS42 === "[object Float64Array]") {
              vIii16 += vLSFl64;
            } else {
              p13047(new Error("Failed to get type for BinaryArray"));
            }
          }
          p13047(vIii16 + f1671(v10401));
        } else if (vLS42 === "[object Blob]") {
          var v10402 = new FileReader();
          v10402.onload = function () {
            var v10403 = vLSlocal_forage_type + p13046.type + "~" + f1671(this.result);
            p13047(vLS__lfsc__ + vLSBlob + v10403);
          };
          v10402.readAsArrayBuffer(p13046);
        } else {
          try {
            p13047(JSON.stringify(p13046));
          } catch (e110) {
            console.error("Couldn't convert value into a JSON string: ", p13046);
            p13047(null, e110);
          }
        }
      }
      function f1673(p13048) {
        if (p13048.substring(0, v10474) !== vLS__lfsc__) {
          return JSON.parse(p13048);
        }
        var v10404;
        var v10405 = p13048.substring(v10475);
        var v10406 = p13048.substring(v10474, v10475);
        if (v10406 === vLSBlob && v10473.test(v10405)) {
          var v10407 = v10405.match(v10473);
          v10404 = v10407[1];
          v10405 = v10405.substring(v10407[0].length);
        }
        var vF1670 = f1670(v10405);
        switch (v10406) {
          case vLSArbf:
            return vF1670;
          case vLSBlob:
            return f1636([vF1670], {
              type: v10404
            });
          case vLSSi08:
            return new Int8Array(vF1670);
          case vLSUi08:
            return new Uint8Array(vF1670);
          case vLSUic8:
            return new Uint8ClampedArray(vF1670);
          case vLSSi16:
            return new Int16Array(vF1670);
          case vLSUr16:
            return new Uint16Array(vF1670);
          case vLSSi32:
            return new Int32Array(vF1670);
          case vLSUi32:
            return new Uint32Array(vF1670);
          case vLSFl32:
            return new Float32Array(vF1670);
          case vLSFl64:
            return new Float64Array(vF1670);
          default:
            throw new Error("Unkown type: " + v10406);
        }
      }
      function f1674(p13049, p13050, p13051, p13052) {
        p13049.executeSql("CREATE TABLE IF NOT EXISTS " + p13050.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], p13051, p13052);
      }
      function f1675(p13053) {
        var vThis108 = this;
        var vO323 = {
          db: null
        };
        if (p13053) {
          for (var v10408 in p13053) {
            vO323[v10408] = typeof p13053[v10408] == "string" ? p13053[v10408] : p13053[v10408].toString();
          }
        }
        var v10409 = new vPromise(function (p13054, p13055) {
          try {
            vO323.db = openDatabase(vO323.name, vO323.version + "", vO323.description, vO323.size);
          } catch (e111) {
            return p13055(e111);
          }
          vO323.db.transaction(function (p13056) {
            f1674(p13056, vO323, function () {
              vThis108._dbInfo = vO323;
              p13054();
            }, function (p13057, p13058) {
              p13055(p13058);
            });
          }, p13055);
        });
        vO323.serializer = vO327;
        return v10409;
      }
      function f1676(p13059, p13060, p13061, p13062, p13063, p13064) {
        p13059.executeSql(p13061, p13062, p13063, function (p13065, p13066) {
          if (p13066.code === p13066.SYNTAX_ERR) {
            p13065.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [p13060.storeName], function (p13067, p13068) {
              if (p13068.rows.length) {
                p13064(p13067, p13066);
              } else {
                f1674(p13067, p13060, function () {
                  p13067.executeSql(p13061, p13062, p13063, p13064);
                }, p13064);
              }
            }, p13064);
          } else {
            p13064(p13065, p13066);
          }
        }, p13064);
      }
      function f1677(p13069, p13070) {
        var vThis109 = this;
        p13069 = f1639(p13069);
        var v10410 = new vPromise(function (p13071, p13072) {
          vThis109.ready().then(function () {
            var v10411 = vThis109._dbInfo;
            v10411.db.transaction(function (p13073) {
              f1676(p13073, v10411, "SELECT * FROM " + v10411.storeName + " WHERE key = ? LIMIT 1", [p13069], function (p13074, p13075) {
                var v10412 = p13075.rows.length ? p13075.rows.item(0).value : null;
                if (v10412) {
                  v10412 = v10411.serializer.deserialize(v10412);
                }
                p13071(v10412);
              }, function (p13076, p13077) {
                p13072(p13077);
              });
            });
          }).catch(p13072);
        });
        f1637(v10410, p13070);
        return v10410;
      }
      function f1678(p13078, p13079) {
        var vThis110 = this;
        var v10413 = new vPromise(function (p13080, p13081) {
          vThis110.ready().then(function () {
            var v10414 = vThis110._dbInfo;
            v10414.db.transaction(function (p13082) {
              f1676(p13082, v10414, "SELECT * FROM " + v10414.storeName, [], function (p13083, p13084) {
                var v10415 = p13084.rows;
                for (var v10416 = v10415.length, vLN01656 = 0; vLN01656 < v10416; vLN01656++) {
                  var v10417 = v10415.item(vLN01656);
                  var v10418 = v10417.value;
                  if (v10418) {
                    v10418 = v10414.serializer.deserialize(v10418);
                  }
                  v10418 = p13078(v10418, v10417.key, vLN01656 + 1);
                  if (v10418 !== undefined) {
                    p13080(v10418);
                    return;
                  }
                }
                p13080();
              }, function (p13085, p13086) {
                p13081(p13086);
              });
            });
          }).catch(p13081);
        });
        f1637(v10413, p13079);
        return v10413;
      }
      function f1679(p13087, p13088, p13089, p13090) {
        var vThis111 = this;
        p13087 = f1639(p13087);
        var v10419 = new vPromise(function (p13091, p13092) {
          vThis111.ready().then(function () {
            if (p13088 === undefined) {
              p13088 = null;
            }
            var vP13088 = p13088;
            var v10420 = vThis111._dbInfo;
            v10420.serializer.serialize(p13088, function (p13093, p13094) {
              if (p13094) {
                p13092(p13094);
              } else {
                v10420.db.transaction(function (p13095) {
                  f1676(p13095, v10420, "INSERT OR REPLACE INTO " + v10420.storeName + " (key, value) VALUES (?, ?)", [p13087, p13093], function () {
                    p13091(vP13088);
                  }, function (p13096, p13097) {
                    p13092(p13097);
                  });
                }, function (p13098) {
                  if (p13098.code === p13098.QUOTA_ERR) {
                    if (p13090 > 0) {
                      p13091(f1679.apply(vThis111, [p13087, vP13088, p13089, p13090 - 1]));
                      return;
                    }
                    p13092(p13098);
                  }
                });
              }
            });
          }).catch(p13092);
        });
        f1637(v10419, p13089);
        return v10419;
      }
      function f1680(p13099, p13100, p13101) {
        return f1679.apply(this, [p13099, p13100, p13101, 1]);
      }
      function f1681(p13102, p13103) {
        var vThis112 = this;
        p13102 = f1639(p13102);
        var v10421 = new vPromise(function (p13104, p13105) {
          vThis112.ready().then(function () {
            var v10422 = vThis112._dbInfo;
            v10422.db.transaction(function (p13106) {
              f1676(p13106, v10422, "DELETE FROM " + v10422.storeName + " WHERE key = ?", [p13102], function () {
                p13104();
              }, function (p13107, p13108) {
                p13105(p13108);
              });
            });
          }).catch(p13105);
        });
        f1637(v10421, p13103);
        return v10421;
      }
      function f1682(p13109) {
        var vThis113 = this;
        var v10423 = new vPromise(function (p13110, p13111) {
          vThis113.ready().then(function () {
            var v10424 = vThis113._dbInfo;
            v10424.db.transaction(function (p13112) {
              f1676(p13112, v10424, "DELETE FROM " + v10424.storeName, [], function () {
                p13110();
              }, function (p13113, p13114) {
                p13111(p13114);
              });
            });
          }).catch(p13111);
        });
        f1637(v10423, p13109);
        return v10423;
      }
      function f1683(p13115) {
        var vThis114 = this;
        var v10425 = new vPromise(function (p13116, p13117) {
          vThis114.ready().then(function () {
            var v10426 = vThis114._dbInfo;
            v10426.db.transaction(function (p13118) {
              f1676(p13118, v10426, "SELECT COUNT(key) as c FROM " + v10426.storeName, [], function (p13119, p13120) {
                var v10427 = p13120.rows.item(0).c;
                p13116(v10427);
              }, function (p13121, p13122) {
                p13117(p13122);
              });
            });
          }).catch(p13117);
        });
        f1637(v10425, p13115);
        return v10425;
      }
      function f1684(p13123, p13124) {
        var vThis115 = this;
        var v10428 = new vPromise(function (p13125, p13126) {
          vThis115.ready().then(function () {
            var v10429 = vThis115._dbInfo;
            v10429.db.transaction(function (p13127) {
              f1676(p13127, v10429, "SELECT key FROM " + v10429.storeName + " WHERE id = ? LIMIT 1", [p13123 + 1], function (p13128, p13129) {
                var v10430 = p13129.rows.length ? p13129.rows.item(0).key : null;
                p13125(v10430);
              }, function (p13130, p13131) {
                p13126(p13131);
              });
            });
          }).catch(p13126);
        });
        f1637(v10428, p13124);
        return v10428;
      }
      function f1685(p13132) {
        var vThis116 = this;
        var v10431 = new vPromise(function (p13133, p13134) {
          vThis116.ready().then(function () {
            var v10432 = vThis116._dbInfo;
            v10432.db.transaction(function (p13135) {
              f1676(p13135, v10432, "SELECT key FROM " + v10432.storeName, [], function (p13136, p13137) {
                var vA570 = [];
                for (var vLN01657 = 0; vLN01657 < p13137.rows.length; vLN01657++) {
                  vA570.push(p13137.rows.item(vLN01657).key);
                }
                p13133(vA570);
              }, function (p13138, p13139) {
                p13134(p13139);
              });
            });
          }).catch(p13134);
        });
        f1637(v10431, p13132);
        return v10431;
      }
      function f1686(p13140) {
        return new vPromise(function (p13141, p13142) {
          p13140.transaction(function (p13143) {
            p13143.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (p13144, p13145) {
              var vA571 = [];
              for (var vLN01658 = 0; vLN01658 < p13145.rows.length; vLN01658++) {
                vA571.push(p13145.rows.item(vLN01658).name);
              }
              p13141({
                db: p13140,
                storeNames: vA571
              });
            }, function (p13146, p13147) {
              p13142(p13147);
            });
          }, function (p13148) {
            p13142(p13148);
          });
        });
      }
      function f1687(p13149, p13150) {
        p13150 = f1640.apply(this, arguments);
        var v10433 = this.config();
        p13149 = typeof p13149 != "function" && p13149 || {};
        if (!p13149.name) {
          p13149.name = p13149.name || v10433.name;
          p13149.storeName = p13149.storeName || v10433.storeName;
        }
        var v10434;
        var vThis117 = this;
        v10434 = p13149.name ? new vPromise(function (p13151) {
          var v10435;
          v10435 = p13149.name === v10433.name ? vThis117._dbInfo.db : openDatabase(p13149.name, "", "", 0);
          if (p13149.storeName) {
            p13151({
              db: v10435,
              storeNames: [p13149.storeName]
            });
          } else {
            p13151(f1686(v10435));
          }
        }).then(function (p13152) {
          return new vPromise(function (p13153, p13154) {
            p13152.db.transaction(function (p13155) {
              function f1688(p13156) {
                return new vPromise(function (p13157, p13158) {
                  p13155.executeSql("DROP TABLE IF EXISTS " + p13156, [], function () {
                    p13157();
                  }, function (p13159, p13160) {
                    p13158(p13160);
                  });
                });
              }
              var vA572 = [];
              for (var vLN01659 = 0, v10436 = p13152.storeNames.length; vLN01659 < v10436; vLN01659++) {
                vA572.push(f1688(p13152.storeNames[vLN01659]));
              }
              vPromise.all(vA572).then(function () {
                p13153();
              }).catch(function (p13161) {
                p13154(p13161);
              });
            }, function (p13162) {
              p13154(p13162);
            });
          });
        }) : vPromise.reject("Invalid arguments");
        f1637(v10434, p13150);
        return v10434;
      }
      function f1689() {
        try {
          return typeof localStorage != "undefined" && "setItem" in localStorage && !!localStorage.setItem;
        } catch (e112) {
          return false;
        }
      }
      function f1690(p13163, p13164) {
        var v10437 = p13163.name + "/";
        if (p13163.storeName !== p13164.storeName) {
          v10437 += p13163.storeName + "/";
        }
        return v10437;
      }
      function f1691() {
        var vLS_localforage_support = "_localforage_support_test";
        try {
          localStorage.setItem(vLS_localforage_support, true);
          localStorage.removeItem(vLS_localforage_support);
          return false;
        } catch (e113) {
          return true;
        }
      }
      function f1692() {
        return !f1691() || localStorage.length > 0;
      }
      function f1693(p13165) {
        var vThis118 = this;
        var vO324 = {};
        if (p13165) {
          for (var v10438 in p13165) {
            vO324[v10438] = p13165[v10438];
          }
        }
        vO324.keyPrefix = f1690(p13165, vThis118._defaultConfig);
        if (!f1692()) {
          return vPromise.reject();
        } else {
          vThis118._dbInfo = vO324;
          vO324.serializer = vO327;
          return vPromise.resolve();
        }
      }
      function f1694(p13166) {
        var vThis119 = this;
        var v10439 = vThis119.ready().then(function () {
          var v10440;
          var v10441 = vThis119._dbInfo.keyPrefix;
          for (var v10442 = localStorage.length - 1; v10442 >= 0; v10442--) {
            v10440 = localStorage.key(v10442);
            if (v10440.indexOf(v10441) === 0) {
              localStorage.removeItem(v10440);
            }
          }
        });
        f1637(v10439, p13166);
        return v10439;
      }
      function f1695(p13167, p13168) {
        var vThis120 = this;
        p13167 = f1639(p13167);
        var v10443 = vThis120.ready().then(function () {
          var v10444 = vThis120._dbInfo;
          var v10445 = localStorage.getItem(v10444.keyPrefix + p13167);
          if (v10445) {
            v10445 = v10444.serializer.deserialize(v10445);
          }
          return v10445;
        });
        f1637(v10443, p13168);
        return v10443;
      }
      function f1696(p13169, p13170) {
        var vThis121 = this;
        var v10446 = vThis121.ready().then(function () {
          var v10447;
          var v10448 = vThis121._dbInfo;
          var v10449 = v10448.keyPrefix;
          var v10450 = v10449.length;
          for (var v10451 = localStorage.length, vLN1147 = 1, vLN01660 = 0; vLN01660 < v10451; vLN01660++) {
            v10447 = localStorage.key(vLN01660);
            if (v10447.indexOf(v10449) === 0) {
              var v10452 = localStorage.getItem(v10447);
              if (v10452) {
                v10452 = v10448.serializer.deserialize(v10452);
              }
              v10452 = p13169(v10452, v10447.substring(v10450), vLN1147++);
              if (v10452 !== undefined) {
                return v10452;
              }
            }
          }
        });
        f1637(v10446, p13170);
        return v10446;
      }
      function f1697(p13171, p13172) {
        var vThis122 = this;
        var v10453 = vThis122.ready().then(function () {
          var v10454;
          var v10455 = vThis122._dbInfo;
          try {
            v10454 = localStorage.key(p13171);
          } catch (e114) {
            v10454 = null;
          }
          if (v10454) {
            v10454 = v10454.substring(v10455.keyPrefix.length);
          }
          return v10454;
        });
        f1637(v10453, p13172);
        return v10453;
      }
      function f1698(p13173) {
        var vThis123 = this;
        var v10456 = vThis123.ready().then(function () {
          var v10457;
          var v10458 = vThis123._dbInfo;
          for (var v10459 = localStorage.length, vA573 = [], vLN01661 = 0; vLN01661 < v10459; vLN01661++) {
            v10457 = localStorage.key(vLN01661);
            if (v10457.indexOf(v10458.keyPrefix) === 0) {
              vA573.push(v10457.substring(v10458.keyPrefix.length));
            }
          }
          return vA573;
        });
        f1637(v10456, p13173);
        return v10456;
      }
      function f1699(p13174) {
        var vThis124 = this;
        var v10460 = vThis124.keys().then(function (p13175) {
          return p13175.length;
        });
        f1637(v10460, p13174);
        return v10460;
      }
      function f1700(p13176, p13177) {
        var vThis125 = this;
        p13176 = f1639(p13176);
        var v10461 = vThis125.ready().then(function () {
          var v10462 = vThis125._dbInfo;
          localStorage.removeItem(v10462.keyPrefix + p13176);
        });
        f1637(v10461, p13177);
        return v10461;
      }
      function f1701(p13178, p13179, p13180) {
        var vThis126 = this;
        p13178 = f1639(p13178);
        var v10463 = vThis126.ready().then(function () {
          if (p13179 === undefined) {
            p13179 = null;
          }
          var vP13179 = p13179;
          return new vPromise(function (p13181, p13182) {
            var v10464 = vThis126._dbInfo;
            v10464.serializer.serialize(p13179, function (p13183, p13184) {
              if (p13184) {
                p13182(p13184);
              } else {
                try {
                  localStorage.setItem(v10464.keyPrefix + p13178, p13183);
                  p13181(vP13179);
                } catch (e115) {
                  if (e115.name === "QuotaExceededError" || e115.name === "NS_ERROR_DOM_QUOTA_REACHED") {
                    p13182(e115);
                  }
                  p13182(e115);
                }
              }
            });
          });
        });
        f1637(v10463, p13180);
        return v10463;
      }
      function f1702(p13185, p13186) {
        p13186 = f1640.apply(this, arguments);
        p13185 = typeof p13185 != "function" && p13185 || {};
        if (!p13185.name) {
          var v10465 = this.config();
          p13185.name = p13185.name || v10465.name;
          p13185.storeName = p13185.storeName || v10465.storeName;
        }
        var v10466;
        var vThis127 = this;
        v10466 = p13185.name ? new vPromise(function (p13187) {
          if (p13185.storeName) {
            p13187(f1690(p13185, vThis127._defaultConfig));
          } else {
            p13187(p13185.name + "/");
          }
        }).then(function (p13188) {
          var v10467;
          for (var v10468 = localStorage.length - 1; v10468 >= 0; v10468--) {
            v10467 = localStorage.key(v10468);
            if (v10467.indexOf(p13188) === 0) {
              localStorage.removeItem(v10467);
            }
          }
        }) : vPromise.reject("Invalid arguments");
        f1637(v10466, p13186);
        return v10466;
      }
      function f1703(p13189, p13190) {
        p13189[p13190] = function () {
          var vArguments = arguments;
          return p13189.ready().then(function () {
            return p13189[p13190].apply(p13189, vArguments);
          });
        };
      }
      function f1704() {
        var v10469;
        for (var vLN1148 = 1; vLN1148 < arguments.length; vLN1148++) {
          v10469 = arguments[vLN1148];
          if (v10469) {
            for (var v10470 in v10469) {
              if (v10469.hasOwnProperty(v10470)) {
                arguments[0][v10470] = v10478(v10469[v10470]) ? v10469[v10470].slice() : v10469[v10470];
              }
            }
          }
        }
        return arguments[0];
      }
      var v10471 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (p13191) {
        return typeof p13191;
      } : function (p13192) {
        if (p13192 && typeof Symbol == "function" && p13192.constructor === Symbol && p13192 !== Symbol.prototype) {
          return "symbol";
        } else {
          return typeof p13192;
        }
      };
      var vF1634 = f1634();
      if (typeof Promise == "undefined") {
        p12926(3);
      }
      var vPromise = Promise;
      var vLSLocalforagedetectblo = "local-forage-detect-blob-support";
      var vUndefined7 = undefined;
      var vO325 = {};
      var v10472 = Object.prototype.toString;
      var vLSReadonly = "readonly";
      var vLSReadwrite = "readwrite";
      var vO326 = {
        _driver: "asyncStorage",
        _initStorage: f1658,
        _support: f1635(),
        iterate: f1661,
        getItem: f1660,
        setItem: f1662,
        removeItem: f1663,
        clear: f1664,
        length: f1665,
        key: f1666,
        keys: f1667,
        dropInstance: f1668
      };
      var vLSABCDEFGHIJKLMNOPQRST3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      var vLSlocal_forage_type = "~~local_forage_type~";
      var v10473 = /^~~local_forage_type~([^~]+)~/;
      var vLS__lfsc__ = "__lfsc__:";
      var v10474 = vLS__lfsc__.length;
      var vLSArbf = "arbf";
      var vLSBlob = "blob";
      var vLSSi08 = "si08";
      var vLSUi08 = "ui08";
      var vLSUic8 = "uic8";
      var vLSSi16 = "si16";
      var vLSSi32 = "si32";
      var vLSUr16 = "ur16";
      var vLSUi32 = "ui32";
      var vLSFl32 = "fl32";
      var vLSFl64 = "fl64";
      var v10475 = v10474 + vLSArbf.length;
      var v10476 = Object.prototype.toString;
      var vO327 = {
        serialize: f1672,
        deserialize: f1673,
        stringToBuffer: f1670,
        bufferToString: f1671
      };
      var vO328 = {
        _driver: "webSQLStorage",
        _initStorage: f1675,
        _support: f1669(),
        iterate: f1678,
        getItem: f1677,
        setItem: f1680,
        removeItem: f1681,
        clear: f1682,
        length: f1683,
        key: f1684,
        keys: f1685,
        dropInstance: f1687
      };
      var vO329 = {
        _driver: "localStorageWrapper",
        _initStorage: f1693,
        _support: f1689(),
        iterate: f1696,
        getItem: f1695,
        setItem: f1701,
        removeItem: f1700,
        clear: f1694,
        length: f1699,
        key: f1697,
        keys: f1698,
        dropInstance: f1702
      };
      var vIii17 = function f1705(p13193, p13194) {
        return p13193 === p13194 || typeof p13193 == "number" && typeof p13194 == "number" && isNaN(p13193) && isNaN(p13194);
      };
      var vIii18 = function f1706(p13195, p13196) {
        for (var v10477 = p13195.length, vLN01662 = 0; vLN01662 < v10477;) {
          if (vIii17(p13195[vLN01662], p13196)) {
            return true;
          }
          vLN01662++;
        }
        return false;
      };
      var v10478 = Array.isArray || function (p13197) {
        return Object.prototype.toString.call(p13197) === "[object Array]";
      };
      var vO330 = {};
      var vO331 = {};
      var vO332 = {
        INDEXEDDB: vO326,
        WEBSQL: vO328,
        LOCALSTORAGE: vO329
      };
      var vA574 = [vO332.INDEXEDDB._driver, vO332.WEBSQL._driver, vO332.LOCALSTORAGE._driver];
      var vA575 = ["dropInstance"];
      var v10479 = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(vA575);
      var vO333 = {
        description: "",
        driver: vA574.slice(),
        name: "localforage",
        size: 4980736,
        storeName: "keyvaluepairs",
        version: 1
      };
      var vF88 = function () {
        function f1707(p13198) {
          f1633(this, f1707);
          for (var v10480 in vO332) {
            if (vO332.hasOwnProperty(v10480)) {
              var v10481 = vO332[v10480];
              var v10482 = v10481._driver;
              this[v10480] = v10482;
              if (!vO330[v10482]) {
                this.defineDriver(v10481);
              }
            }
          }
          this._defaultConfig = f1704({}, vO333);
          this._config = f1704({}, this._defaultConfig, p13198);
          this._driverSet = null;
          this._initDriver = null;
          this._ready = false;
          this._dbInfo = null;
          this._wrapLibraryMethodsWithReady();
          this.setDriver(this._config.driver).catch(function () {});
        }
        f1707.prototype.config = function f1708(p13199) {
          if ((typeof p13199 == "undefined" ? "undefined" : v10471(p13199)) === "object") {
            if (this._ready) {
              return new Error("Can't call config() after localforage has been used.");
            }
            for (var v10483 in p13199) {
              if (v10483 == "storeName") {
                p13199[v10483] = p13199[v10483].replace(/\W/g, "_");
              }
              if (v10483 == "version" && typeof p13199[v10483] != "number") {
                return new Error("Database version must be a number.");
              }
              this._config[v10483] = p13199[v10483];
            }
            return !("driver" in p13199) || !p13199.driver || this.setDriver(this._config.driver);
          }
          if (typeof p13199 == "string") {
            return this._config[p13199];
          } else {
            return this._config;
          }
        };
        f1707.prototype.defineDriver = function f1709(p13200, p13201, p13202) {
          var v10484 = new vPromise(function (p13203, p13204) {
            try {
              var v10485 = p13200._driver;
              var v10486 = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
              if (!p13200._driver) {
                p13204(v10486);
                return;
              }
              var v10487 = v10479.concat("_initStorage");
              for (var vLN01663 = 0, v10488 = v10487.length; vLN01663 < v10488; vLN01663++) {
                var v10489 = v10487[vLN01663];
                var v10490 = !vIii18(vA575, v10489);
                if ((v10490 || p13200[v10489]) && typeof p13200[v10489] != "function") {
                  p13204(v10486);
                  return;
                }
              }
              var vIii19 = function f1710() {
                var v10491;
                var vI22 = function f1711(p13205) {
                  return function () {
                    var v10492 = new Error("Method " + p13205 + " is not implemented by the current driver");
                    var v10493 = vPromise.reject(v10492);
                    f1637(v10493, arguments[arguments.length - 1]);
                    return v10493;
                  };
                };
                for (var vLN01664 = 0, v10494 = vA575.length; vLN01664 < v10494; vLN01664++) {
                  v10491 = vA575[vLN01664];
                  if (!p13200[v10491]) {
                    p13200[v10491] = vI22(v10491);
                  }
                }
              };
              vIii19();
              var vIiii12 = function f1712(p13206) {
                if (vO330[v10485]) {
                  console.info("Redefining LocalForage driver: " + v10485);
                }
                vO330[v10485] = p13200;
                vO331[v10485] = p13206;
                p13203();
              };
              if ("_support" in p13200) {
                if (p13200._support && typeof p13200._support == "function") {
                  p13200._support().then(vIiii12, p13204);
                } else {
                  vIiii12(!!p13200._support);
                }
              } else {
                vIiii12(true);
              }
            } catch (e116) {
              p13204(e116);
            }
          });
          f1638(v10484, p13201, p13202);
          return v10484;
        };
        f1707.prototype.driver = function f1713() {
          return this._driver || null;
        };
        f1707.prototype.getDriver = function f1714(p13207, p13208, p13209) {
          var v10495 = vO330[p13207] ? vPromise.resolve(vO330[p13207]) : vPromise.reject(new Error("Driver not found."));
          f1638(v10495, p13208, p13209);
          return v10495;
        };
        f1707.prototype.getSerializer = function f1715(p13210) {
          var v10496 = vPromise.resolve(vO327);
          f1638(v10496, p13210);
          return v10496;
        };
        f1707.prototype.ready = function f1716(p13211) {
          var vThis128 = this;
          var v10497 = vThis128._driverSet.then(function () {
            if (vThis128._ready === null) {
              vThis128._ready = vThis128._initDriver();
            }
            return vThis128._ready;
          });
          f1638(v10497, p13211, p13211);
          return v10497;
        };
        f1707.prototype.setDriver = function f1717(p13212, p13213, p13214) {
          function f1718() {
            vThis129._config.driver = vThis129.driver();
          }
          function f1719(p13215) {
            vThis129._extend(p13215);
            f1718();
            vThis129._ready = vThis129._initStorage(vThis129._config);
            return vThis129._ready;
          }
          function f1720(p13216) {
            return function () {
              function f1721() {
                while (vLN01665 < p13216.length) {
                  var v10498 = p13216[vLN01665];
                  vLN01665++;
                  vThis129._dbInfo = null;
                  vThis129._ready = null;
                  return vThis129.getDriver(v10498).then(f1719).catch(f1721);
                }
                f1718();
                var v10499 = new Error("No available storage method found.");
                vThis129._driverSet = vPromise.reject(v10499);
                return vThis129._driverSet;
              }
              var vLN01665 = 0;
              return f1721();
            };
          }
          var vThis129 = this;
          if (!v10478(p13212)) {
            p13212 = [p13212];
          }
          var v10500 = this._getSupportedDrivers(p13212);
          var v10501 = this._driverSet === null ? vPromise.resolve() : this._driverSet.catch(function () {
            return vPromise.resolve();
          });
          this._driverSet = v10501.then(function () {
            var v10502 = v10500[0];
            vThis129._dbInfo = null;
            vThis129._ready = null;
            return vThis129.getDriver(v10502).then(function (p13217) {
              vThis129._driver = p13217._driver;
              f1718();
              vThis129._wrapLibraryMethodsWithReady();
              vThis129._initDriver = f1720(v10500);
            });
          }).catch(function () {
            f1718();
            var v10503 = new Error("No available storage method found.");
            vThis129._driverSet = vPromise.reject(v10503);
            return vThis129._driverSet;
          });
          f1638(this._driverSet, p13213, p13214);
          return this._driverSet;
        };
        f1707.prototype.supports = function f1722(p13218) {
          return !!vO331[p13218];
        };
        f1707.prototype._extend = function f1723(p13219) {
          f1704(this, p13219);
        };
        f1707.prototype._getSupportedDrivers = function f1724(p13220) {
          var v10504;
          var vA576 = [];
          for (var vLN01666 = 0, v10505 = p13220.length; vLN01666 < v10505; vLN01666++) {
            v10504 = p13220[vLN01666];
            if (this.supports(v10504)) {
              vA576.push(v10504);
            }
          }
          return vA576;
        };
        f1707.prototype._wrapLibraryMethodsWithReady = function f1725() {
          for (var vLN01667 = 0, v10506 = v10479.length; vLN01667 < v10506; vLN01667++) {
            f1703(this, v10479[vLN01667]);
          }
        };
        f1707.prototype.createInstance = function f1726(p13221) {
          return new f1707(p13221);
        };
        return f1707;
      }();
      var v10507 = new vF88();
      p12927.exports = v10507;
    }, {
      3: 3
    }]
  }, {}, [4])(4);
});